import React, { useState } from 'react';
import { motion } from 'framer-motion';


import w1 from '../assests/wedding_webp/1.webp';
import w2 from '../assests/wedding_webp/2.webp';
import w3 from '../assests/wedding_webp/_30A6723.webp';
import w4 from '../assests/wedding_webp/_30A7708.webp';
import w5 from '../assests/wedding_webp/_30A6605.webp';

import pw1 from '../assests/prewedding_webp/04.webp';
import pw2 from '../assests/prewedding_webp/05.webp';
import pw3 from '../assests/prewedding_webp/07.webp';
import pw4 from '../assests/prewedding_webp/08.webp';
import pw5 from '../assests/prewedding_webp/19.webp';
import pw6 from '../assests/prewedding_webp/A_A.webp';

import h1 from '../assests/haldi_webp/01.webp';
import h2 from '../assests/haldi_webp/02.webp';
import h3 from '../assests/haldi_webp/03.webp';
import h4 from '../assests/haldi_webp/04.webp';

import bs1 from '../assests/babyshower_webp/19.webp';
import bs2 from '../assests/babyshower_webp/v2.webp';
import bs3 from '../assests/babyshower_webp/03.webp';
import bs4 from '../assests/babyshower_webp/04.webp';

import eng1 from '../assests/eng_webp/01.webp';
import eng2 from '../assests/eng_webp/02.webp';


const tabs = ['Wedding', 'Pre-Wedding', 'Haldi', 'Babyshower', 'Engagement'];


const images = {
    Wedding: [
      { src: w1, width: 600, height: 400 },
      { src: w2, width: 400, height: 500 },
      { src: w3, width: 700, height: 500 },
      { src: w4, width: 500, height: 350 },
      { src: w5, width: 600, height: 450 },
    ],
    'Pre-Wedding': [
      { src: pw1, width: 600, height: 400 },
      { src: pw2, width: 400, height: 300 },
      { src: pw3, width: 700, height: 500 },
      { src: pw4, width: 500, height: 350 },
      { src: pw5, width: 600, height: 450 },
      { src: pw6, width: 500, height: 400 },
    ],
    Haldi: [
      { src: h1, width: 600, height: 400 },
      { src: h2, width: 400, height: 300 },
      { src: h3, width: 700, height: 500 },
      { src: h4, width: 500, height: 350 },
    ],
    Babyshower: [
      { src: bs1, width: 300, height: 300 },
      { src: bs2, width: 300, height: 300 },
      { src: bs3, width: 700, height: 500 },
      { src: bs4, width: 500, height: 350 },
    ],
    Engagement: [
      { src: eng1, width: 600, height: 400 },
      { src: eng2, width: 400, height: 300 },
    ],
  };
  
//   const PortfolioCarousel = () => {
//     const [activeTab, setActiveTab] = useState('Wedding');
  
//     return (
//       <div className="bg-[#f9f4ee] p-4 md:p-8">
//         <div className="max-w-7xl mx-auto">
//           <div className="flex flex-wrap justify-center gap-2 mb-8">
//             {tabs.map((tab) => (
//              <button
//              key={tab}
//              className={`px-6 py-2 text-sm sm:text-base whitespace-nowrap rounded-full transition-all duration-300 ${
//                activeTab === tab
//                  ? 'bg-gray-800 text-white shadow-lg'
//                  : 'bg-white text-gray-800 hover:bg-gray-100 border border-gray-300'
//              } focus:outline-none focus:ring-2 focus:ring-gray-400`}
//              onClick={() => setActiveTab(tab)}
//            >
//              {tab}
//            </button>
//             ))}
//           </div>
  
//           <div className="mb-8">
//             <MobileCarousel images={images[activeTab]} />
//             <DesktopGallery images={images[activeTab]} />
//           </div>
  
//           <div className="flex justify-center">
//   <button className="bg-gray-800 text-white py-3 px-6 rounded-full hover:bg-gray-700 transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-gray-400">
//     View All 
//   </button>
// </div>
//         </div>
//       </div>
//     );
//   };
  
//   const MobileCarousel = ({ images }) => {
//     const [width, setWidth] = useState(0);
//     const carousel = useRef();
  
//     useEffect(() => {
//       const updateWidth = () => {
//         if (carousel.current) {
//           const scrollWidth = carousel.current.scrollWidth;
//           const offsetWidth = carousel.current.offsetWidth;
//           setWidth(scrollWidth - offsetWidth);
//         }
//       };
  
//       updateWidth();
//       window.addEventListener('resize', updateWidth);
  
//       const timer = setTimeout(updateWidth, 100);
  
//       return () => {
//         window.removeEventListener('resize', updateWidth);
//         clearTimeout(timer);
//       };
//     }, [images]);
  
//     return (
//       <div className="md:hidden overflow-hidden">
//         <motion.div
//           ref={carousel}
//           className="flex"
//           drag="x"
//           dragConstraints={{ right: 0, left: -width }}
//           dragElastic={0.1}
//           dragTransition={{ bounceStiffness: 600, bounceDamping: 20 }}
//           style={{ touchAction: 'pan-y' }}
//         >
//           {images.map((img, index) => (
//             <motion.div 
//               key={index} 
//               className="flex-shrink-0 mr-4 last:mr-0"
//             >
//               <img 
//                 src={img.src} 
//                 alt={`Portfolio ${index + 1}`} 
//                 className="h-64 w-auto object-cover rounded-lg shadow-md"
//                 style={{ 
//                   width: 'auto', 
//                   height: '256px',
//                   aspectRatio: `${img.width} / ${img.height}`
//                 }}
//               />
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>
//     );
//   };
  
//   const DesktopGallery = ({ images }) => {
//     return (
//       <div className="hidden md:grid grid-cols-3 lg:grid-cols-4 gap-3">
//         {images.map((img, index) => (
//           <div
//             key={index}
//             className={`rounded-lg overflow-hidden shadow-md transition-transform duration-300 hover:scale-105 ${
//               index % 7 === 0 ? 'col-span-2 row-span-2' : ''
//             }`}
//           >
//             <img 
//               src={img.src} 
//               alt={`Portfolio ${index + 1}`} 
//               className="w-full h-full object-cover"
//               style={{ aspectRatio: `${img.width} / ${img.height}` }}
//             />
//           </div>
//         ))}
//       </div>
//     );
//   };

const buttonColors = {
    Wedding: 'bg-gray-800 text-white shadow-lg',
    'Pre-Wedding': 'bg-gray-800 text-white shadow-lg',
    Haldi: 'bg-gray-800 text-white shadow-lg',
    Babyshower: 'bg-gray-800 text-white shadow-lg',
    Engagement: 'bg-gray-800 text-white shadow-lg',
  };
  
  const PortfolioCarousel = () => {
    const [activeTab, setActiveTab] = useState('Wedding');
  
    return (
      <div className="bg-[#f9f4ee] p-4 md:p-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-2 mb-8">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`px-6 py-2 text-sm sm:text-base whitespace-nowrap rounded-full transition-all duration-300 ${
                  activeTab === tab
                    ? 'bg-gray-800 text-white shadow-lg'
                    : 'bg-white text-gray-800 hover:bg-gray-100 border border-gray-300'
                } focus:outline-none focus:ring-2 focus:ring-gray-400`}
                onClick={() => setActiveTab(tab)}
              >
                {tab}
              </button>
            ))}
          </div>
  
          <div className="relative">
            <div style={{width:'100%'}} className="title absolute top-[-265px] flex flex-col items-center justify-center gap-2">
                  <h2 style={{fontWeight:'400'}} className='text-4xl font-fontc text-gray-900 md:text-5xl lg:text-5xl'>Explore Portfolio</h2>
                  <p style={{textAlign:'center'}} className='text-xl text-gray-600 mt-2 lg:mt-5 lg:text-2xl'>Browse through our stunning collections of Wedding & Other Events</p>
            </div>
            <motion.div 
              className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              {images[activeTab].map((img, index) => (
                <motion.div
                  key={index}
                  className={`rounded-lg overflow-hidden shadow-md ${
                    index === 0 ? 'col-span-2 row-span-2' : ''
                  }`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                >
                  <img  loading='lazy'
                    src={img.src} 
                    alt={`Portfolio ${index + 1}`} 
                    className="w-full h-full object-cover"
                    style={{ aspectRatio: `${img.width} / ${img.height}` }}
                  />
                </motion.div>
              ))}
            </motion.div>
  
            <div className="sm:hidden absolute inset-x-0 bottom-[-15px] h-1/2 bg-gradient-to-t from-[#f9f4ee] to-transparent pointer-events-none"></div>
            
            <div className="relative sm:flex sm:justify-center sm:mt-1 text-center">
  <button className="absolute bottom-5 left-1/2 transform -translate-x-1/2 sm:relative sm:bottom-auto sm:left-auto sm:transform-none sm:mt-10">
    <a 
      href={`/${activeTab.toLowerCase()}`}
      className={`inline-block text-white py-3 px-6 rounded-full transition-colors shadow-lg focus:outline-none focus:ring-2 focus:ring-gray-400 ${buttonColors[activeTab]}`}
    >
      View More
    </a>
  </button>
</div>
          </div>
        </div>
      </div>
    );
  };
  
  export default PortfolioCarousel;
  

